/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React from 'react'
import DashboardIcon from '@material-ui/icons/DashboardOutlined'
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
import MoneyOutlinedIcon from '@material-ui/icons/MoneyOutlined';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import PostAddOutlinedIcon from '@material-ui/icons/PostAddOutlined';
import SupervisedUserCircleOutlinedIcon from '@material-ui/icons/SupervisedUserCircleOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import StorefrontOutlinedIcon from "@material-ui/icons/StorefrontOutlined";

import {FormattedMessage} from "react-intl"

export default [
    {
        subheader: "Admin Controls",
        items: [
            {
                title: "Dashboard",
                href: '/dashboard',
                icon: DashboardIcon
            },
            {
                title: "Stores",
                href: '/stores',
                icon: StorefrontOutlinedIcon,
                items: [
                    {
                        title: "Stores",
                        href: '/stores/list'
                    },
                    {
                        title: "Products",
                        href: '/stores/products'
                    },
                ],
            },


            {
                title: "Installments",
                href: '/installments',
                icon: MonetizationOnOutlinedIcon,
                items: [
                    {
                        title: 'Invoice',
                        href: '/installments/invoice'
                    },
                    {
                        title: 'Due',
                        href: '/installments/due'
                    },
                    {
                        title: 'Report',
                        href: '/installments/report'
                    },
                    {
                        title: 'Clients',
                        href: '/installments/clients'
                    }
                ]
            },

            {
                title: "Cash",
                href: '/cash',
                icon: MoneyOutlinedIcon,
                items: [
                    {
                        title: 'Invoices',
                        href: '/cash/invoices'
                    },
                    {
                        title: 'Report',
                        href: '/cash/report'
                    }
                ]
            },
            {
                title: "Vendors",
                href: '/vendors',
                icon: AddBoxOutlinedIcon,
                items: [
                    {
                        title: 'Vendors',
                        href: 'vendors/vendors'
                    },
                    {
                        title: ' Invoice',
                        href: '/vendors/invoice'
                    },
                    {
                        title: 'Report',
                        href: '/vendors/report'
                    },
                ]
            },
            {
                title: "Accounts",
                href: '/accounts',
                icon: AccountBalanceWalletOutlinedIcon,
            },
            {
                title: "Branches",
                href: '/branches',
                icon: PostAddOutlinedIcon,
            },
            {
                title: "Reports",
                href: '/reports',
                icon: AssignmentOutlinedIcon
            },
            {
                title: "User Management",
                href: '/users',
                icon: SupervisedUserCircleOutlinedIcon,
                items: [
                    {
                        title: "Permissions",
                        href: '/users/permissions'
                    },
                    {
                        title: "Roles",
                        href: '/users/roles'
                    },
                    {
                        title: "Users",
                        href: '/users/users'
                    }
                ]
            }
        ]
    }
]
